"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as c } from "react";
import l from "../components/Icon/SvgIcon.js";
const e = (t) => /* @__PURE__ */ o(
  l,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "m4.16 11.756 5.265 2.303a1 1 0 0 1 .516.516l2.303 5.265c.354.81 1.506.796 1.841-.02L20.09 5.216c.338-.821-.483-1.643-1.305-1.305L4.18 9.915c-.816.335-.83 1.487-.02 1.84Z"
      }
    )
  }
), s = c(e);
export {
  s as LocationAccessFilled,
  s as default
};
